
import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Favorites() {
  const [favorites, setFavorites] = useState([
    {
      id: 1,
      name: 'طماطم طازجة - كيلو',
      price: '12',
      rating: 4.8,
      image: 'https://public.readdy.ai/ai/img_res/b43a248860b331947028690f35e470ea.jpg'
    },
    {
      id: 2,
      name: 'حليب طازج - لتر',
      price: '15',
      rating: 4.9,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20milk%20bottle%20dairy%20product%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20white%20and%20blue%20packaging%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=400&height=400&seq=favgro2&orientation=squarish'
    },
    {
      id: 3,
      name: 'خبز طازج',
      price: '8',
      rating: 4.7,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20bread%20loaf%20bakery%20product%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20golden%20brown%20color%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=400&height=400&seq=favgro3&orientation=squarish'
    },
    {
      id: 4,
      name: 'تفاح أحمر - كيلو',
      price: '18',
      rating: 5.0,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20red%20apples%20fruit%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20bright%20red%20color%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=400&height=400&seq=favgro4&orientation=squarish'
    },
    {
      id: 5,
      name: 'دجاج طازج - كيلو',
      price: '35',
      rating: 4.6,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20chicken%20meat%20poultry%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=400&height=400&seq=favgro5&orientation=squarish'
    },
    {
      id: 6,
      name: 'عصير برتقال - لتر',
      price: '12',
      rating: 4.8,
      image: 'https://readdy.ai/api/search-image?query=Fresh%20orange%20juice%20bottle%20beverage%2C%20high-quality%20product%20photography%2C%20isolated%20on%20clean%20white%20background%2C%20centered%20composition%2C%20professional%20studio%20lighting%2C%20minimalist%20aesthetic%2C%20orange%20color%20packaging%2C%20detailed%20texture%2C%20sharp%20focus%2C%20commercial%20grocery%20product%20shot%2C%20simple%20and%20clean&width=400&height=400&seq=favgro6&orientation=squarish'
    }
  ]);

  const removeFavorite = (id: number) => {
    setFavorites(favorites.filter(item => item.id !== id));
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-pink-50 pb-20" dir="rtl">
      {/* Header */}
      <div className="fixed top-0 w-full bg-white/80 backdrop-blur-lg shadow-sm z-50">
        <div className="px-4 py-3 flex items-center justify-between">
          <Link to="/" className="w-10 h-10 flex items-center justify-center">
            <i className="ri-arrow-right-line text-2xl text-gray-800"></i>
          </Link>
          <h1 className="text-xl font-bold text-gray-800">المفضلة</h1>
          <div className="w-10"></div>
        </div>
      </div>

      {/* Content */}
      <div className="pt-20 px-4">
        {favorites.length > 0 ? (
          <>
            <div className="mb-4 flex items-center justify-between">
              <p className="text-gray-600">
                <span className="font-bold text-gray-800">{favorites.length}</span> منتج في المفضلة
              </p>
              <button className="text-sm text-red-500 font-medium">
                حذف الكل
              </button>
            </div>

            <div className="grid grid-cols-2 gap-3" data-product-shop>
              {favorites.map((product) => (
                <div
                  key={product.id}
                  className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
                >
                  <Link to={`/product/${product.id}`} className="block">
                    <div className="relative h-40 overflow-hidden">
                      <img 
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="p-3">
                      <h4 className="font-bold text-gray-800 text-sm mb-1 line-clamp-2">{product.name}</h4>
                      <div className="flex items-center gap-1 mb-2">
                        <i className="ri-star-fill text-yellow-400 text-xs"></i>
                        <span className="text-xs font-medium text-gray-700">{product.rating}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-lg font-bold bg-gradient-to-r from-pink-600 to-red-600 bg-clip-text text-transparent">{product.price} ر.س</span>
                      </div>
                    </div>
                  </Link>
                  <div className="px-3 pb-3">
                    <button
                      onClick={() => removeFavorite(product.id)}
                      className="w-full py-2.5 bg-red-50 text-red-500 rounded-xl font-medium text-sm hover:bg-red-100 transition-colors flex items-center justify-center gap-2"
                    >
                      <i className="ri-heart-fill"></i>
                      إزالة من المفضلة
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className="flex flex-col items-center justify-center py-20">
            <div className="w-48 h-48 mb-6">
              <img 
                src="https://readdy.ai/api/search-image?query=3D%20illustration%20of%20empty%20favorites%20wishlist%20concept%2C%20cute%20heart%20icon%20with%20sad%20expression%2C%20pastel%20pink%20and%20purple%20colors%2C%20minimalist%20design%2C%20centered%20composition%2C%20soft%20lighting%2C%20professional%20digital%20art%2C%20clean%20background%2C%20isometric%20perspective&width=400&height=400&seq=emptyfav1&orientation=squarish"
                alt="Empty"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="text-xl font-bold text-gray-800 mb-2">لا توجد منتجات مفضلة</h3>
            <p className="text-gray-500 text-center mb-6">ابدأ بإضافة منتجاتك المفضلة</p>
            <Link
              to="/"
              className="px-8 py-3 bg-gradient-to-r from-pink-500 to-red-500 text-white rounded-2xl font-bold shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              تصفح المنتجات
            </Link>
          </div>
        )}
      </div>

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 w-full bg-white shadow-lg border-t border-gray-100 z-50">
        <div className="grid grid-cols-5 h-16">
          <Link to="/" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-home-line text-xl"></i>
            <span className="text-xs">الرئيسية</span>
          </Link>
          <Link to="/explore" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-search-line text-xl"></i>
            <span className="text-xs">استكشف</span>
          </Link>
          <Link to="/cart" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors relative">
            <i className="ri-shopping-cart-line text-xl"></i>
            <span className="text-xs">السلة</span>
            <span className="absolute top-1 right-1/2 translate-x-3 w-5 h-5 bg-gradient-to-r from-red-500 to-pink-500 text-white text-xs font-bold rounded-full flex items-center justify-center">3</span>
          </Link>
          <button className="flex flex-col items-center justify-center gap-1 text-blue-600">
            <i className="ri-heart-fill text-xl"></i>
            <span className="text-xs">المفضلة</span>
          </button>
          <Link to="/profile" className="flex flex-col items-center justify-center gap-1 text-gray-400 hover:text-gray-600 transition-colors">
            <i className="ri-user-line text-xl"></i>
            <span className="text-xs">حسابي</span>
          </Link>
        </div>
      </nav>
    </div>
  );
}
